import { ExperimentType } from 'ha/modules/Experiments';

const Experiments: { [name: string]: ExperimentType } = {
  HA5972: {
    name: '[HA-5972] Cancellation Policies',
    variants: ['A', 'B', 'C'],
    weights: [33.34, 33.33, 33.33],
  },
  HA8438: {
    name: '[HA-8438] Update search date logic',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA8501: {
    name: '[HA-8501] Update subscriptions paywall design',
    variants: ['A', 'B'],
    weights: [50, 50],
  },

  TNT478: {
    name: '[TNT-478] Flexible Search Dates',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  TNT809: {
    name: '[TNT-809] Integrate TopPlace location page on LDP map',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  TX233: {
    name: '[TX-233]: Show urgency on LDP',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  TX1490: {
    name: '[TX-1490]: Show quick search filters',
    variants: ['A', 'B', 'C'],
    weights: [33.34, 33.33, 33.33],
  },
  TX1659: {
    name: '[FE] Experiment Skip conversation success page',
    variants: ['A', 'B'],
    weights: [50, 50],
  },

  /* Growth */
  MON2260: {
    name: '[MON-2260] Book-request with mandates',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  //Reorder payIN module sections
  MON2375: {
    name: '[MON-2375] Payment form arrangement',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
};

export { Experiments };
